import React from "react";
import SprZalMain from "./spr-zal-main";
import SprZalSchedule from "./spr-zal-schedule";

export const ZAL_TAB_KEYS = {
  MAIN: "main",
  SCHEDULE: "schedule"
};

export const ZAL_TAB_ITEMS = [
  { key: ZAL_TAB_KEYS.MAIN, label: "Основная" },
  { key: ZAL_TAB_KEYS.SCHEDULE, label: "График работы" }
];

/**
 * Карточка кабинета / группы: контент активной вкладки.
 */
const SprZalCard = ({
  idZal,
  isNew = false,
  idUpper,
  open,
  activeTab,
  parentOptions,
  onSaved,
  onCancel
}) => {
  const mainProps = { idZal, isNew, idUpper, open, parentOptions, onSaved, onCancel };

  if (isNew) {
    return <SprZalMain {...mainProps} />;
  }

  switch (activeTab) {
    case ZAL_TAB_KEYS.SCHEDULE:
      return <SprZalSchedule idZal={idZal} open={open} />;
    case ZAL_TAB_KEYS.MAIN:
    default:
      return <SprZalMain {...mainProps} />;
  }
};

export default SprZalCard;
